let setFrame = window.requestAnimationFrame;
let delFrame = window.cancelAnimationFrame;

if (typeof setFrame !== 'function') {
    setFrame = fn => window.setTimeout(fn, 1000 / 60);
    delFrame = window.clearTimeout;
}

export {
    setFrame,
    delFrame
};



// WEBPACK FOOTER //
// ./src/lib/frames.js